import { call, fork, put, select } from 'redux-saga/effects';
import 'signalr';
import { photoCaptureIntelligentDamageConnectionFailureAction, photoCaptureIntelligentDamageConnectionSuccessAction } from '../actions';
import { PhotoCaptureIntelligentDamageConnectionService } from '../services';
import { getIsSignalRConnected, getPhotoCaptureSignalRConnectionId } from '../selectors';
import { getInitializedDamageConnectionArtifactsSaga, watchPhotoCaptureSignalRConnectionEventsSaga, getErrorMessagesBasedOnStatusCode } from '../utilities';
const intelligentPhotoCaptureDamageConnectionService = new PhotoCaptureIntelligentDamageConnectionService();
/**
 * Saga to handle SignalR negotiation request
 * @param action - The action triggering the saga
 * @param signalRService - The SignalR service instance (for dependency injection)
 * @yields Effects for Redux-Saga
 */
export function* intelligentPhotoCaptureDamageConnectionSaga(_action, signalRService = intelligentPhotoCaptureDamageConnectionService) {
    try {
        // If SignalR is already established, re-confirm the existing connection and exit.
        // This prevents renegotiation when onRequestDamageConnection is called redundantly.
        const isAlreadyConnected = (yield select(getIsSignalRConnected));
        const existingConnectionId = (yield select(getPhotoCaptureSignalRConnectionId));
        if (isAlreadyConnected && existingConnectionId) {
            yield put(photoCaptureIntelligentDamageConnectionSuccessAction(existingConnectionId));
            return;
        }
        yield call([signalRService, signalRService.negotiateDamageConnection]);
        const { signalRConnectionEvents, connectionId } = yield call(getInitializedDamageConnectionArtifactsSaga, signalRService);
        yield fork(watchPhotoCaptureSignalRConnectionEventsSaga, signalRConnectionEvents);
        yield put(photoCaptureIntelligentDamageConnectionSuccessAction(connectionId));
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureIntelligentDamageConnectionFailureAction(errorMessage));
    }
}
export function* intelligentPhotoCaptureDamageConnectionDeleteSaga(_action, signalRService = intelligentPhotoCaptureDamageConnectionService) {
    yield call([signalRService, signalRService.disconnectDamageConnection]);
}
//# sourceMappingURL=intelligentPhotoCaptureDamageConnectionSaga.js.map